import React from 'react';
import { Building2, User, Store, Dumbbell, Hotel, Briefcase } from 'lucide-react';

export const ClientTypesSection = () => {
  const clientTypes = [
    {
      icon: Dumbbell,
      title: 'Sportscholen & Fitnesscentra',
      description: 'Complete installatie van fitnessapparatuur, van cardio tot kracht. Nieuwe gyms inrichten of bestaande apparatuur vervangen.',
      examples: ['Gym inrichting', 'Apparatuur wisselen', 'Krachtlijn montage']
    },
    {
      icon: Hotel,
      title: 'Hotels & Resorts',
      description: 'Fitnessruimtes voor hotels professioneel ingericht. Transport en installatie van loopbanden, fietsen en krachttoestellen.',
      examples: ['Hotelgym setup', 'Cardio installatie', 'Onderhoud']
    },
    {
      icon: Building2,
      title: 'Bedrijfsfitness',
      description: 'Kantoren en bedrijven voorzien van fitnessapparatuur. Van ontwerp tot installatie van de complete fitnessruimte.',
      examples: ['Kantoor gym', 'Apparatuur plaatsen', 'Vloer inrichting']
    },
    {
      icon: Store,
      title: 'Fitnesswinkels & Dealers',
      description: 'Transport en levering van fitnessapparatuur voor dealers en winkels. Last-mile delivery naar eindklanten.',
      examples: ['Dealer levering', 'Klant installatie', 'Retourlogistiek']
    },
    {
      icon: User,
      title: 'Particulieren & Thuisgyms',
      description: 'Thuisgym laten installeren? Wij plaatsen loopbanden, krachtstations en meer bij u thuis.',
      examples: ['Thuisgym setup', 'Loopband plaatsen', 'Krachtstation montage']
    },
    {
      icon: Briefcase,
      title: 'Revalidatiecentra & Fysio',
      description: 'Installatie van gespecialiseerde apparatuur voor revalidatie- en fysiotherapiecentra.',
      examples: ['Revalidatie apparatuur', 'Therapietoestellen', 'Verplaatsing']
    }
  ];

  return (
    <section className="py-14 lg:py-20 bg-neutral-50 relative overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-yellow-100/40 rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-neutral-200/50 rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-4 relative">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-flex items-center gap-2 bg-yellow-100 text-yellow-400 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            Voor wie?
          </span>
          <h2 className="text-4xl md:text-5xl font-black text-neutral-900 mb-6">
            Wij helpen <span className="gradient-text">diverse klanten</span>
          </h2>
          <p className="text-xl text-neutral-600 leading-relaxed">
            Van sportschool tot thuisgym, Nexon Installatie & Service biedt maatwerkoplossingen voor elke klant en elke fitnessruimte.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {clientTypes.map((client) => (
            <div 
              key={client.title}
              className="group bg-white p-8 rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-500 border-2 border-transparent hover:border-yellow-100 hover:-translate-y-2"
            >
              <div className="flex items-start gap-5">
                <div className="w-14 h-14 bg-yellow-400 rounded-2xl flex items-center justify-center shadow-lg shadow-yellow-400/20 group-hover:scale-110 transition-transform duration-300 flex-shrink-0">
                  <client.icon className="w-7 h-7 text-white" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-neutral-900 mb-2">{client.title}</h3>
                  <p className="text-neutral-600 text-sm leading-relaxed mb-4">{client.description}</p>
                  <div className="flex flex-wrap gap-2">
                    {client.examples.map((example) => (
                      <span key={example} className="text-xs bg-neutral-100 text-neutral-600 px-3 py-1 rounded-full">
                        {example}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
